module.exports = __webpack_public_path__ + "static/media/arror-expand.be3b4518.svg";